import './storydata.css'
import { useState } from "react";

export default function Storydata({ addStory, removeStory, stories = [] }) {
  const [title, setTitle] = useState('');
  const [banner, setBanner] = useState('');
  const [matn, setMatn] = useState('');
  const [colormatn, setColormatn] = useState('');
  const [colorbanner, setColorbanner] = useState('');

  const handleAddStory = async () => {
    if (title && banner && matn) {
      const storydataget = {
        title,
        banner,
        matn,
        colormatn,
        colorbanner,
      }
      try {
        const response = await fetch('http://185.164.73.170:5000/api/stories', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(storydataget),
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const addedStory = await response.json();
        addStory(addedStory);
        setTitle('');
        setBanner('');
        setMatn('');
      } catch (error) {
        console.error("Failed to add story:", error);
      }
    }
  };

  return (
    <div className="storydata">
      <input
        type="text"
        placeholder="عنوان استوری"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />
      <input
        type="text"
        placeholder="بنر استوری"
        value={banner}
        onChange={(e) => setBanner(e.target.value)}
      />
      <textarea
        type="text"
        placeholder="متن استوری"
        value={matn}
        onChange={(e) => setMatn(e.target.value)}
      />
      <p>رنگ متن استوری</p>
      <input
        type="color"
        placeholder="رنگ متن استوری"
        className='colorinput'
        value={colormatn}
        onChange={(e) => setColormatn(e.target.value)}
      />
      <p>رنگ پس زمینه استوری</p>
      <input
        type="color"
        placeholder="رنگ بنر استوری"
        className='colorinput'
        value={colorbanner}
        onChange={(e) => setColorbanner(e.target.value)}
      />
      <button onClick={handleAddStory}>افزودن استوری</button>
      <div className='storyaddedbox'>
      <ul className='storyadded'>
        {stories.map(story => (
          <li key={story.id}>
            <p>موضوع : {story.title}</p>
            <p>متن بنر : {story.banner}</p>
            <p>متن : {story.matn}</p>
            <button onClick={() => removeStory(story.id)}>حذف</button>
          </li>
        ))}
      </ul>
      </div>
    </div>
  );
}